export const LocalStorageUtils = {
  /**
   * Reads and parses the 'readyChek' object from window.localStorage.
   * Returns an empty object if not set or if parsing fails.
   * @returns {Object}
   */
  getReadyChek() {
    try {
      const data = window.localStorage.getItem('readyChek') || window.localStorage['readyChek'];
      if (!data) return {};
      return JSON.parse(data) || {};
    } catch (e) {
      console.error('Error parsing readyChek from localStorage:', e);
      return {};
    }
  },

  /**
   * Merges the provided patch object into the existing 'readyChek' JSON object in window.localStorage.
   * Preserves all existing keys not overwritten by the patch.
   * @param {Object} patch 
   * @returns {Object} The updated storage object
   */
  setReadyChek(patch) {
    try {
      const current = this.getReadyChek();
      const updated = { ...current, ...patch };
      window.localStorage.setItem('readyChek', JSON.stringify(updated));
      return updated;
    } catch (e) {
      console.error('Error saving readyChek to localStorage:', e);
      return {};
    }
  }
};

export default LocalStorageUtils;
